import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
const ImpersonationContext = createContext({
    impersonated: null,
    startImpersonation: () => { },
    stopImpersonation: () => { },
});
const STORAGE_KEY = 'impersonated_commune';
export function ImpersonationProvider({ children }) {
    const [impersonated, setImpersonated] = useState(() => {
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : null;
        }
        catch {
            return null;
        }
    });
    // Persist impersonation across reloads. The axios X-Commune-Slug header is
    // applied centrally in CommuneProvider (single writer) from this value.
    useEffect(() => {
        if (impersonated) {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(impersonated));
        }
        else {
            sessionStorage.removeItem(STORAGE_KEY);
        }
    }, [impersonated]);
    const queryClient = useQueryClient();
    // Les clés de cache ne portent pas la commune (['settings'], ['commune-config']...) :
    // changer de commune sans vider le cache réaffichait les données de la précédente.
    const resetTenantCache = () => {
        void queryClient.cancelQueries();
        queryClient.removeQueries();
    };
    const startImpersonation = (commune) => {
        if (commune.slug !== impersonated?.slug)
            resetTenantCache();
        setImpersonated(commune);
    };
    const stopImpersonation = () => {
        if (impersonated)
            resetTenantCache();
        setImpersonated(null);
    };
    return (_jsx(ImpersonationContext.Provider, { value: { impersonated, startImpersonation, stopImpersonation }, children: children }));
}
export function useImpersonation() {
    return useContext(ImpersonationContext);
}
